import {RaEvent, RaEventType} from "./RaEvent";
import {IUserModelDelta} from "../services/usermodel/usermodel.objects";

export class WordWallStepEvent extends RaEvent {
    static TYPE:RaEventType = "word_wall_step_event";
    constructor() {
        super(WordWallStepEvent.TYPE)
    }
}

export class PreviewStepEvent extends RaEvent {
    static TYPE:RaEventType = "preview_step_event";
    constructor() {
        super(PreviewStepEvent.TYPE)
    }
}

export class ReadAndRecordStepEvent extends RaEvent {
    static TYPE:RaEventType = "read_and_record_step_event";
    constructor() {
        super(ReadAndRecordStepEvent.TYPE)
    }
}

export class QuizStepEvent extends RaEvent {
    static TYPE:RaEventType = "quiz_step_event";
    constructor() {
        super(QuizStepEvent.TYPE)
    }
}

export class PointsChangedEvent extends RaEvent {
    static TYPE: RaEventType = "points_changed_event";
    constructor() {
        super(PointsChangedEvent.TYPE)
    }
}

export class PointCounterEvent extends RaEvent {
    static TYPE: RaEventType = "point_counter_event";
    constructor(private state: string, private value: number) {
        super(PointCounterEvent.TYPE);
    }

    public getState(): string {
        return this.state;
    }

    public getValue(): number {
        return this.value;
    }
}

export class StepStatusEvent extends RaEvent {
    static TYPE:RaEventType = "step_status_event";

    constructor(private key:RaEventType, private value:number) {
        super(StepStatusEvent.TYPE);
    }

    public getKey():RaEventType {
        return this.key;
    }

    public getValue():number {
        return this.value;
    }
}

export class StepAllowedEvent extends RaEvent {
    static TYPE:RaEventType = "step_allowed_event";

    constructor(private key:RaEventType) {
        super(StepAllowedEvent.TYPE);
    }

    public getKey():RaEventType {
        return this.key;
    }

}

export class StepInitializedEvent extends RaEvent {
    static TYPE: RaEventType = "step_initialized_event";

    constructor() {
        super(StepInitializedEvent.TYPE);
    }

}


